export const defaultCurrencySettings = { symbol: '$', code: 'USD' };
